import { useCallback } from "react";

interface UseDragScrollOptions {
  enabled?: boolean;
  preventTextSelection?: boolean;
}

type CallbackRef<T> = (node: T | null) => void;

export function useDragScroll<T extends HTMLElement>(options: UseDragScrollOptions = {}): CallbackRef<T> {
  void options;
  return useCallback(() => {}, []);
}
